import { render, staticRenderFns } from "./PageManualLighting.vue?vue&type=template&id=62dc999c&scoped=true&"
import script from "./PageManualLighting.vue?vue&type=script&lang=js&"
export * from "./PageManualLighting.vue?vue&type=script&lang=js&"
import style0 from "./PageManualLighting.vue?vue&type=style&index=0&id=62dc999c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dc999c",
  null
  
)

export default component.exports